import React from 'react';
import { Link } from 'react-router';

import { BlogPost as BlogPostType } from 'src/blog/types';

import './blog-post.css';

type BlogPostProps = {
  post: BlogPostType;
};

export const BlogPost = ({ post }: BlogPostProps) => (
  <article className="blog-post">
    <Link
      // this check is only for the blog on staging to see the drafts
      to={`/blog/${post.category?.slug}/${post.slug}`}
      className="blog-post__wrapper-link"
    >
      {post.coverImage ? (
        <img
          src={`${post.coverImage.url}?fit=thumb&f=top_left&w=500&h=300`}
          alt={post.coverImage.title}
          className="blog-post__cover-image"
        />
      ) : null}
      <p className="blog-post__category">
        {/* this check is only for the blog on staging to see the drafts */}
        {post.category ? post.category.title : null}
      </p>
      <h3 className="blog-post__title">{post.title}</h3>
      <p className="blog-post__summary">{post.summary}</p>
    </Link>
  </article>
);
